import React from 'react';
import * as styles from './styles.scss';

const ButtonAdd = ({ className, children, ...props }) => (
    <button
        className={`${styles.add}${className ? ` ${className}` : ''}`}
        { ...props }
    >
        {children}
    </button>
);

export default ButtonAdd;
